

import React from "react";
import {Jumbotron} from "reactstrap";

const Row6 = () => {
    return(
        <div>
            <br/><br/>
      <hr/>
      <Jumbotron className="jumbobg2">
        <div></div>
      </Jumbotron>
      <hr/>
      </div>
      );
        
    
}

export default Row6 ;